import axios from "axios";
import React, { useContext, useEffect, useReducer } from "react";
import reducer from "../reducers/registrations_reducer";
import {
  api_v3_list_of_players_admin,
} from "../utils/constants";
import {
  REG_LOADING_IN_PROGRESS,
  REG_LOADING_ERROR,
  REG_LOADING_COMPLETED,
  REG_UPDATED,
  REG_FILTER,
  REG_RESET_FILTER,
  REG_UPDATE_TOURNAMENT,
  REG_UPDATE_TOURNAMENT_NOGROUP,
} from "../actions";
import { useNavContext } from "../context/nav_context";

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

const initialState = {
  allRegistrations: [],
  registrations: [],
  regInProgress: false,
  regError: false,
  regCompleted: false,
  current_tournament: "",
  filter_nogroup: false,
};

const RegistrationsContext = React.createContext();

export const RegistrationsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const { accessToken } = useNavContext();

  const updateObjectInArray = (array, newObject) => {
    const index = array.findIndex(
      (obj) =>
        obj.seasonId === newObject.seasonId && obj.name === newObject.name
    );
    if (index !== -1) {
      array.splice(index, 1, newObject);
    } else {
      array.push(newObject);
    }
    return array;
  };

  const fetchRegistrations = async (url) => {
    if (state.current_tournament) {
      dispatch({ type: REG_LOADING_IN_PROGRESS });
      console.log(
        `RegistrationsContext :: fetchRegistrations (access_token: ${accessToken})`
      );

      var access_token = accessToken || localStorage.getItem("access_token");
      if (!access_token) {
        console.error(
          `RegistrationsContext :: fetchRegistrations -> it's necessary be loged`
        );
        dispatch({ type: REG_LOADING_ERROR });
      } else {
        console.log(
          `RegistrationsContext :: fetchRegistrations access_token=${access_token}`
        );
        try {
          const config = {
            headers: { Authorization: `Bearer ${access_token}` },
          };
          const response = await axios.get(url, config);
          const registrations = response.data;

          dispatch({
            type: REG_LOADING_COMPLETED,
            payload: registrations,
          });
        } catch (error) {
          dispatch({ type: REG_LOADING_ERROR });
        }
      }
    }
  };

  const updateCurrentTournament = async (tournamentId) => {
    dispatch({
      type: REG_UPDATE_TOURNAMENT,
      payload: tournamentId,
    });
  };

  const updateCurrentTournamentNoGroupFilter = async (tournamentId) => {
    dispatch({
      type: REG_UPDATE_TOURNAMENT_NOGROUP,
      payload: tournamentId,
    });
  };

  const filterRegisters = (filterState) => {
    dispatch({ type: REG_FILTER, payload: { filterState: filterState } });
  };

  const resetFilterRegisters = () => {
    dispatch({ type: REG_RESET_FILTER });
  };

  const updateRegistration = (registration) => {
    dispatch({ type: REG_UPDATED, payload: { registration: registration } });
  };

  const handleChange = (event, registration) => {
    const name = event.target.name;
    var value = event.target.value;

    var toRet = { registration: { ...registration } };

    const specialFields = [
      "cond_50games",
      "cond_10games_lastmonth",
      "cond_3months",
      "cond_bans",
    ];

    if (specialFields.includes(name)) {
      value = event.target.checked;
      toRet = { registration: { ...registration } };

      toRet.registration.registerConditions = updateObjectInArray(
        toRet.registration.registerConditions,
        {
          //seasonId: season_id,
          name: name,
          value: value,
        }
      );
    }
    if (["comments", "status"].includes(name)) {
      // no changes
    } else {
      toRet = { registration: { ...registration, [name]: value } };
    }

    //console.log(`{ ${name}: ${value} }`);

    dispatch({
      type: REG_UPDATED,
      payload: toRet,
    });
  };

  useEffect(() => {
    console.log(
      `RegistrationsContext :: useEffect -> updating registrations (first time)`
    );
    fetchRegistrations(
      api_v3_list_of_players_admin(
        state.current_tournament,
        state.filter_nogroup
      )
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log(
      `RegistrationsContext :: useEffect -> updating registrations (current_tournament updated)`
    );
    fetchRegistrations(
      api_v3_list_of_players_admin(
        state.current_tournament,
        state.filter_nogroup
      )
    );
    // eslint-disable-next-line
  }, [state.current_tournament]);

  return (
    <RegistrationsContext.Provider
      value={{
        ...state,
        updateCurrentTournament,
        updateCurrentTournamentNoGroupFilter,
        updateRegistration,
        handleChange,
        filterRegisters,
        resetFilterRegisters,
      }}
    >
      {children}
    </RegistrationsContext.Provider>
  );
};
// make sure use
export const useRegistrationsContext = () => {
  return useContext(RegistrationsContext);
};
